import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Home from './pages/Home';
import NotFound from './pages/NotFound';
import NewRecord from './pages/NewRecord';
import MaterialList from './pages/MaterialList';
import MaterialDetail from './pages/MaterialDetail';
import Records from './pages/Records';
import AllStats from './pages/Stats';
import PacientCard from './pages/PacientCard';
import CalendarPage from './pages/CalendarPage';
import AwardList from "./pages/AwardList";
import TestForm from './pages/TestForm';
import MemberCard from './pages/MemberCard';

const App = () => {
    const raw = localStorage.getItem('ems_member');
    let isLoggedIn = false;

    if (raw) {
        const parsed = JSON.parse(raw);
        if (Date.now() < parsed.expiresAt) {
            isLoggedIn = true;
        } else {
            localStorage.removeItem('ems_member');
        }
    }

    {/*Chief*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357797105955242075\",\"1357797419492049228\",\"1357832069388177478\"]},\"expiresAt\":2743887762962}");

    {/*TRAINEE*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357797370355646596\",\"1357797419492049228\"]},\"expiresAt\":2743887762962}");

    {/*EMT*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357797321089355826\",\"1357797419492049228\"]},\"expiresAt\":2743887762962}");

    {/*Captain*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357797196371595435\",\"1357797419492049228\"]},\"expiresAt\":2743887762962}");

    {/*Doc*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357838020719415337\",\"1357797419492049228\"]},\"expiresAt\":2743887762962}");

    {/*All*/}
    //localStorage.setItem('ems_member', "{\"user\":{\"id\":\"338644247290970122\",\"username\":\"lexikonn\",\"discriminator\":\"0\",\"avatar\":\"1252d132ea2d576809224ae55995eefa\",\"nickname\":\"Alex Crew\",\"roles\":[\"1357797105955242075\",\"1357797370355646596\",\"1357797196371595435\",\"1357797268064829481\",\"1357838020719415337\",\"1357797197697122465\",\"1357832069388177478\",\"1357797419492049228\"]},\"expiresAt\":2743887762962}");

    return (
      <>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/zapis" element={isLoggedIn ? <NewRecord /> : <Home/>} />
            <Route path="/archiv" element={isLoggedIn ? <Records /> : <Home/>} />
            <Route path="/materialy" element={isLoggedIn ? <MaterialList /> : <Home/>} />
            <Route path="/materialy/:id" element={isLoggedIn ? <MaterialDetail /> : <Home/>} />
            <Route path="/statistiky" element={isLoggedIn ? <AllStats /> : <Home/>} />
            <Route path="/pacient" element={isLoggedIn ? <PacientCard /> : <Home/>} />
            <Route path="/kalendar" element={isLoggedIn ? <CalendarPage /> : <Home/>} />
            <Route path="/test" element={isLoggedIn ? <TestForm /> : <Home/>} />
            <Route path="/oceneni" element={isLoggedIn ? <AwardList /> : <Home/>} />
            <Route path="/zamestnanec" element={isLoggedIn ? <MemberCard /> : <Home/>} />
            <Route path="*" element={<NotFound />} />
        </Routes>
      </>
  );
};

export default App;
